var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.6732 1.75h-7.2357l4.6041 6.13922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.3269 1.75 2.63157 6.13922 4.60413-6.13922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 4.08344-3.5 4.66648h7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.13 2.7923-2.5533 5.95765h6.1107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.86992 2.7923-3.61211 5.95765h6.16547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.02156 10.5h-6.70906l12.1844 15.75h.029z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.9784 10.5-5.5043 15.75h.029l12.1844-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0136 10.5h-8.02703l4.01353 11.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.a5c114ed214962736e12f5cefd4cf8d9.svg";
export { ForwardRef as ReactComponent };